import { Component } from '@angular/core';

@Component({
  selector: 'app-rp-confirmation',
  templateUrl: './confirmation.component.html',
})
export class ResetPasswordConfirmationComponent {}
